import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const TERMS = {
  ko: [
    {
      title: "제1조 (목적)",
      content: `이 약관은 (주)코리아트래블스토어2가 제공하는 당일 투어 예약 서비스의 이용과 관련하여 회사와 이용자 간의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.`,
    },
    {
      title: "제2조 (정의)",
      content: `① "서비스"란 회사가 제공하는 투어 예약 및 결제 관련 일체의 서비스를 말합니다.
② "이용자"란 이 약관에 따라 회사가 제공하는 서비스를 받는 회원 및 비회원을 말합니다.
③ "회원"이란 회사에 개인정보를 제공하여 회원 등록을 한 자로서, 회사의 서비스를 지속적으로 이용할 수 있는 자를 말합니다.`,
    },
    {
      title: "제3조 (약관의 효력 및 변경)",
      content: `① 이 약관은 서비스 화면에 게시하거나 기타의 방법으로 이용자에게 공지함으로써 효력이 발생합니다.
② 회사는 필요한 경우 관련 법령을 위배하지 않는 범위 내에서 이 약관을 변경할 수 있습니다.
③ 약관이 변경되는 경우 회사는 변경사항을 시행일 7일 전부터 공지합니다.`,
    },
    {
      title: "제4조 (서비스 이용)",
      content: `① 서비스 이용은 회사의 업무상 또는 기술상 특별한 지장이 없는 한 연중무휴 1일 24시간을 원칙으로 합니다.
② 회사는 서비스를 일정 범위로 분할하여 각 범위별로 이용 가능 시간을 별도로 정할 수 있습니다.`,
    },
    {
      title: "제5조 (예약 및 취소)",
      content: `① 이용자는 서비스를 통해 투어를 예약할 수 있습니다.
② 예약 취소는 투어 출발 24시간 전까지 가능하며, 이후 취소 시 환불이 제한될 수 있습니다.
③ 환불 정책은 별도 고지한 환불 규정에 따릅니다.`,
    },
    {
      title: "제6조 (개인정보 보호)",
      content: `회사는 이용자의 개인정보를 보호하기 위해 개인정보처리방침을 수립하고 준수합니다.`,
    },
    {
      title: "제7조 (면책조항)",
      content: `① 회사는 천재지변 등 불가항력적인 사유로 서비스를 제공할 수 없는 경우 책임이 면제됩니다.
② 회사는 이용자의 귀책사유로 인한 서비스 이용 장애에 대하여 책임을 지지 않습니다.`,
    },
    {
      title: "제8조 (분쟁 해결)",
      content: `① 서비스 이용과 관련하여 분쟁이 발생한 경우 회사와 이용자는 성실히 협의합니다.
② 협의가 이루어지지 않을 경우 관할 법원은 회사 소재지를 관할하는 법원으로 합니다.`,
    },
  ],
  en: [
    {
      title: "Article 1 (Purpose)",
      content: `These Terms of Service govern the rights, obligations, and responsibilities between (주)코리아트래블스토어2 ("Company") and users in connection with the use of the one-day tour booking service provided by the Company.`,
    },
    {
      title: "Article 2 (Definitions)",
      content: `① "Service" refers to all tour booking and payment-related services provided by the Company.
② "User" refers to members and non-members who receive services provided by the Company under these Terms.
③ "Member" refers to a person who has registered with the Company by providing personal information and can continuously use the Company's services.`,
    },
    {
      title: "Article 3 (Effect and Modification of Terms)",
      content: `① These Terms take effect by being posted on the service screen or notified to users by other means.
② The Company may modify these Terms within the scope that does not violate relevant laws and regulations.
③ When the Terms are modified, the Company will announce the changes 7 days before the effective date.`,
    },
    {
      title: "Article 4 (Use of Service)",
      content: `① The service is available 24 hours a day, 365 days a year, unless there are business or technical obstacles.
② The Company may divide the service into certain ranges and separately set available hours for each range.`,
    },
    {
      title: "Article 5 (Reservation and Cancellation)",
      content: `① Users may book tours through the service.
② Cancellations are available up to 24 hours before the tour departure; refunds may be restricted after that.
③ Refund policies are subject to separately announced refund regulations.`,
    },
    {
      title: "Article 6 (Privacy Protection)",
      content: `The Company establishes and complies with a Privacy Policy to protect users' personal information.`,
    },
    {
      title: "Article 7 (Disclaimer)",
      content: `① The Company is exempt from liability when services cannot be provided due to force majeure such as natural disasters.
② The Company is not responsible for service disruptions caused by the user's own fault.`,
    },
    {
      title: "Article 8 (Dispute Resolution)",
      content: `① In the event of a dispute related to the use of the service, the Company and the user shall negotiate in good faith.
② If no agreement is reached, the competent court shall be the court having jurisdiction over the Company's location.`,
    },
  ],
};

export default function TermsPage() {
  const navigate = useNavigate();
  const [lang, setLang] = useState("en");

  const sections = TERMS[lang];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* 헤더 */}
      <div className="bg-white border-b border-gray-100 sticky top-0 z-10">
        <div className="max-w-screen-md mx-auto px-6 h-[56px] flex items-center gap-3">
          <button
            onClick={() => navigate(-1)}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            ←
          </button>
          <h1 className="text-[16px] font-bold text-gray-900 flex-1">
            {lang === "ko" ? "이용약관" : "Terms of Service"}
          </h1>
          {/* 언어 탭 */}
          <div className="flex bg-gray-100 rounded-full p-0.5 gap-0.5">
            {["ko", "en"].map((l) => (
              <button
                key={l}
                onClick={() => setLang(l)}
                className={[
                  "px-3 py-1 rounded-full text-[12px] font-semibold transition-all",
                  lang === l ? "bg-white text-gray-800 shadow-sm" : "text-gray-400",
                ].join(" ")}
              >
                {l === "ko" ? "KO" : "EN"}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="max-w-screen-md mx-auto px-6 py-8">
        <p className="text-[13px] text-gray-400 mb-8">
          {lang === "ko" ? "시행일: 2026년 6월 11일" : "Effective Date: June 11, 2026"}
        </p>

        <div className="flex flex-col gap-8">
          {sections.map((section, i) => (
            <div key={i}>
              <h2 className="text-[15px] font-bold text-gray-900 mb-2">{section.title}</h2>
              <p className="text-[14px] text-gray-600 leading-relaxed whitespace-pre-line">{section.content}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 p-5 bg-white rounded-[16px] border border-gray-100">
          <p className="text-[13px] font-semibold text-gray-700 mb-1">
            {lang === "ko" ? "문의" : "Contact"}
          </p>
          <p className="text-[13px] text-gray-400">help@onedaykorea.co.kr</p>
        </div>
      </div>
    </div>
  );
}